import React from 'react';

interface FormLabelProps {
  children?: React.ReactNode;
  className?: string;
  htmlFor?: string;
}

const FormLabel: React.FC<FormLabelProps> = ({ children, className = '', htmlFor }) => {
  return (
    <label htmlFor={htmlFor} className={`block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 ${className}`}>
      {children}
    </label>
  );
};

export default FormLabel;

